<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('campaign')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Banner</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p>Heading</p>
        <base-input
          alternative
          class="mb-3"
          name="heading"
          :rules="{ required: true }"
          placeholder="Heading"
          v-model="heading"
        >
        </base-input>

        <p>Sub Heading</p>
        <base-input
          alternative
          class="mb-3"
          name="Sub Heading"
          :rules="{ required: true }"
          placeholder="Sub Heading"
          v-model="content"
        >
        </base-input>

        <p>Button Label</p>
        <base-input
          alternative
          class="mb-3"
          name="Button Label"
          placeholder="Button Label"
          v-model="btnName"
        >
        </base-input>
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
          ></multiselect>
        </div>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 1400px × 450px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <Cropper
          class="cropper"
          :src="image"
          v-if="coverImage != ''"
          @change="handleCropperChange"
          ref="cropper"
          :stencil-props="{
            aspectRatio: 2 / 1,
          }"
        />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img class="w-1/2" :src="$imageURL + '/' + image2" alt="" />
          <base-button
            v-if="image2"
            type="danger"
            class="px-8"
            @click="handleRemove"
          >
            Remove image
          </base-button>
        </div>

        <div class="py-4 customboxed">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            :rules="{ required: true }"
            placeholder="https://www.example.com"
            v-model="link"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      title: "",
      heading: "",
      link: "",
      image: "",
      image2: "",
      content: "",
      btnName: "",
      coverImage: "",
      cropperImg: "",
      selectedCampaigns: [],
      campaignOptions: [],
      blog_data: {},

      editorOption: {
        theme: "snow",
      },
      linkErr: false,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  watch: {},
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      //data.append("type", "single");
      data.append("_id", this.selectedBanner._id);
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );
      data.append("heading", this.heading);
      data.append("content", this.content);
      data.append("btnName", this.btnName);
      // data.append("image", this.coverImage);
      if (this.coverImage) {
        data.append("image", this.coverImage);
      } else if (this.image2) {
        data.append("image", this.image2);
      }
      data.append("link", this.link);
      let loader = this.$loading();

      if (!this.coverImage && !this.image2) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      try {
        const editData = await this.$store.dispatch(
          "campaignPageBanner/update",
          data
        );
        if (editData.code == 200) {
          this.$router.push({ name: "campaign" });
          this.$swal.fire({
            text: "Banner Successfully Edited",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        loader.close();
      } catch (error) {
        console.log(error);
        // if (error) {
        //   loader.close();
        // }
      }
    },
    async init() {
      // console.log(this.selectedBanner);
      this.blog_data = { ...this.selectedBanner };
      this.heading = this.selectedBanner.heading;
      this.link = this.selectedBanner.link;
      this.content = this.selectedBanner.content;
      this.btnName = this.selectedBanner.btnName;
      this.image2 = this.selectedBanner.image;

      if (this.selectedBanner.selectedCampaigns && this.campaignHome.result) {
        this.selectedCampaigns = this.selectedBanner.selectedCampaigns.map(
          (campaignId) => {
            const campaign = this.campaignHome.result.find(
              (c) => c._id === campaignId
            );
            return campaign
              ? { label: campaign.heading, value: campaign._id }
              : null;
          }
        );
        // .filter(Boolean);
      }
      // else {
      //   this.selectedCampaigns = [];
      // }
    },
    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("campaignPageBanner", {
      selectedBanner: "selectedBanner",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  async mounted() {
    // Fetch the campaign data before initializing the component
    await this.$store.dispatch("campaignPageBanner/get_campaignhome");
    // Populate the dropdown options and initialize the form
    // this.campaignOptions = this.getCampaignOptions();
    this.init();
  },
};
</script>
